import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from './Context';
import Layout from './Layout';

const ProductsConfiguratorPage = (props) => (
  <Provider {...props}>
    <Layout />
  </Provider>
);

ProductsConfiguratorPage.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
// //   productCategories: jsonApiShape(productCategoryShape).isRequired,
// //   products: jsonApiShape(productShape).isRequired,
// //   productVariants: jsonApiShape(productVariantShape).isRequired,
};
//
// ProductsConfiguratorPage.defaultProps = {
// };

export default ProductsConfiguratorPage;
